"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseOneOf = void 0;
const errors_1 = require("./errors");
const parseSchema_1 = require("./parseSchema");
const toBreadcrumb_1 = require("./toBreadcrumb");
const parseOneOf = function ({ path, schema, direction }) {
    if (!schema.oneOf) {
        throw new errors_1.errors.SchemaInvalid(`Property 'oneOf' at '${toBreadcrumb_1.toBreadcrumb(path)}' is missing.`);
    }
    if (!Array.isArray(schema.oneOf)) {
        throw new errors_1.errors.SchemaInvalid(`Property 'oneOf' at '${toBreadcrumb_1.toBreadcrumb(path)}' should be an array.`);
    }
    const graphqlTypeDefinitions = [], graphqlTypeNames = [];
    schema.oneOf.forEach((subSchema, index) => {
        const result = parseSchema_1.parseSchema({ schema: subSchema, direction, path: [...path, `I${index}`] });
        graphqlTypeNames.push(result.typeName);
        graphqlTypeDefinitions.push(...result.typeDefinitions);
    });
    const graphqlTypeName = graphqlTypeNames.
        filter((name) => name.trim() !== '').
        join(' | ');
    return {
        typeName: graphqlTypeName,
        typeDefinitions: graphqlTypeDefinitions
    };
};
exports.parseOneOf = parseOneOf;
